import axios from 'axios';
import { Career } from 'app/shared/model/career.model';

export const getCareersByType = careerType => {
  return axios.get<Career[]>(`/api/careers/by-career-type?careerType=${careerType}`);
};
